
import { defineComponent } from 'vue'
import ContactCardView from '@/components/ContactCardView.vue'

export default defineComponent({
  components: { ContactCardView },
  name: 'ContactUs',
  data: () => ({
    QQ: require('@/assets/images/QQ.svg'),
    whatsapp: require('@/assets/images/whatsapp.svg'),
    telegram: require('@/assets/images/telegram.svg')
    // arr: [] as Array<number> sample
  }),

  mounted() {
    // console.log('randomList', this.randomList)
  },
  methods: {
    isUsingPhone() {
      // this.arr = [2]
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) return true
      return false
    }
  },
  computed: {
    qqHref() {
      if (this.isUsingPhone()) {
        return 'mqqwpa://im/chat?chat_type=wpa&uin=815138493&version=1&src_type=web&web_src=oicqzone.com'
      }
      return 'http://wpa.qq.com/msgrd?v=3&uin=814152521&site=oicqzone.com&menu=yes'
    },
    cardList() {
      const cardList = [
        {
          img: this.QQ,
          title: '联系QQ',
          contactNumber: '814152521',
          href: this.qqHref,
          isClick: true
        },
        {
          img: this.whatsapp,
          title: '联系Whatsapp',
          contactNumber: '在线咨询：+639478898888',
          href: 'https://wa.me/639478898888'
        },
        {
          img: this.telegram,
          title: '联系Telegram',
          contactNumber: '在线咨询：@DN988',
          href: 'https://telegram.me/DN988'
        }
      ]
      return cardList
      // return 'http://wpa.qq.com/msgrd?v=3&uin=815138493&site=oicqzone.com&menu=yes'
    },
    randomList() {
      const randomList = [
        {
          img: this.telegram,
          title: '联系Telegram',
          contactNumber: '在线咨询：@lulutext',
          href: 'https://telegram.me/lulutext'
        }
      ]
      const randomNum = Math.floor(Math.random() * randomList.length)
      const randomView = randomList[randomNum]
      return randomView
    }
  }

})
